import { useCallback } from "react";
import { getTimeEntryAccess } from "../../util/UserHelper";
import { useWorkOrderStore } from "../../store/wo-order";

export default function useGetTimeEntryAccess() {
  const setHasTimeEntryAccess = useWorkOrderStore(
    (state) => state.setWoHasTimeEntryAccess
  );

  const getTimeEntryAccessForWo = useCallback(
    async (woNumber: string) => {
      const userAccess = await getTimeEntryAccess();
      setHasTimeEntryAccess(woNumber, userAccess);
    },
    [setHasTimeEntryAccess]
  );

  return { getTimeEntryAccessForWo };
}
